import React from 'react'
import { input } from '@/styles/theme/components/input'
import type { InputProps } from './types'

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({
        className = '',
        error,
        ...props
    }, ref) => (
        <input
            ref={ref}
            className={`
                ${input.base}
                ${error ? input.error : ''}
                ${className}
            `}
            {...props}
        />
    )
)

Input.displayName = 'Input'

export default Input 